import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppLightComponent} from './app-light.component';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../../../shared/shared.module';

const ROUTES = [
  {
    path: '',
    component: AppLightComponent,
    children: [
      {path: '', loadChildren: () => import('../../../modules/auth/auth.module').then(m => m.AuthModule)},
      {path: '', loadChildren: () => import('../../../modules/valuations/valuations.module').then(m => m.ValuationsModule)},
      {path: '', loadChildren: () => import('../../../modules/viewings/customer-viewing/customer-viewing.module')
          .then(m => m.CustomerViewingModule)
      },
    ]
  }
];

@NgModule({
  declarations: [
    AppLightComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(ROUTES)
  ],
  exports: [
    RouterModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppLightRoutingModule {
}
